// extracted by css-extract-rspack-plugin
var _1 = "AlertIcon-m_alertIcon-It3cw5SO";
export { _1 as "alertIcon" }
